<template>
  <div>
    <Flex options-header
      >{{ label
      }}<Flex class="w-full items-center justify-end"
        ><Icon
          v-if="selectValue"
          src="material/clear"
          class="cursor-pointer"
          @click="clearSelect" /></Flex
    ></Flex>
    <ComponentLookupSelect
      v-model="selectValue"
      :id="component"
      :component="component"
      v-bind:limit-width="true"
      @select="componentFilterUpdated"
    />
  </div>
</template>

<script>
import Flex from '@wizer/core/components/flex/Flex'
import Icon from '@wizer/core/components/icon/Icon'
import ComponentLookupSelect from '../ComponentLookupSelect'

export default {
  name: 'MapComponentFilter',
  components: {
    Flex,
    ComponentLookupSelect,
    Icon,
  },
  props: {
    component: null,
    label: null,
  },
  data() {
    return {
      selectValue: null,
    }
  },
  methods: {
    componentFilterUpdated(value) {
      this.$emit('update', {
        component: this.component,
        value,
        type: 'mapComponentFilterUpdated',
      })
    },
    clearSelect() {
      this.selectValue = null
      this.componentFilterUpdated(null)
    },
  },
}
</script>

<style lang="postcss" scoped>
.options-header {
  @apply p-2 bg-gray-300 font-bold whitespace-no-wrap;
  margin-top: 25px;
}
</style>
